<template>
    <v-container
        class="pa-12 fill-height align-start"
        fluid
    >
        <v-card outlined width="100%">
            <v-card-title>
                Students
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title>
            <v-data-table 
                :loading="loading"
                loading-text="Loading... Please wait"
                :headers="headers"
                :items="students"
                :search="search"
            >
                <template v-slot:item.profile="{ item }">
                    <v-icon v-if="item.completedProfile">mdi-check</v-icon>
                    <v-icon v-else>mdi-minus</v-icon>
                </template>
                <template v-slot:item.country="{ item }">
                    <template v-if="item.country">
                        {{ item.country.label }}
                    </template>
                </template>
                <template v-slot:item.status="{ item }">
                    <template v-if="item.accountConfirmed">
                        <v-icon title="Deactivated" color="secondary" v-if="item.isDeactivated">mdi-account-cancel</v-icon>
                        <v-icon title="Active" color="primary" v-else>mdi-account-check</v-icon>
                    </template>
                    <template v-else>
                        <v-icon title="Waiting for email confirmation!">mdi-email-sync</v-icon>
                    </template>   
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn 
                        small 
                        depressed
                        color="primary" 
                        v-if="item.isDeactivated" 
                        @click="activateAccount(item.id)"
                        :disabled="activatingAccountLoader"
                        :loading="activatingAccountLoader"
                    >Activate</v-btn>
                </template>
                <template v-slot:no-data>
                    <div class="body-2">No data available</div>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'students',
        data: () => ({
            search: '',
            students: [],
            headers: [
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    width: '70',
                    value: 'id'
                },
                { text: 'First name', value: 'firstName' },
                { text: 'Last Name', value: 'lastName' },
                { text: 'Email', value: 'email' },
                { text: 'Country', value: 'country' },
                { 
                    text: 'Status', 
                    value: 'status', 
                    sortable: false,
                    width: '100',
                    align: 'center'
                },
                { 
                    text: 'Actions', 
                    value: 'actions', 
                    sortable: false,
                    width: '200',
                    align: 'center'
                }
            ],
            loading: true,
            activatingAccountLoader: false,
            snackbar: {
                show: true,
                message: ''
            }
        }),
        mounted() {
            this.fetchStudents()
        },
        methods: {
            async fetchStudents() {
                await this.axios.get('/User/GetAllUsersByType', {
                    params: {
                        userType: 2,
                        languageId: 1
                    }
                })
                .then(response => {
                    this.students = response.data.list
                    this.loading = false
                })
                .catch(error => {
                    this.snackbar.message = error.message
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
            },
            activateAccount(id) {
                this.activatingAccountLoader = true
                this.axios.post(`/User/ActivateAccount?userId=${id}`)
                .then(response => {
                    if(response.data) {
                        let index = this.students.map(s => s.id).indexOf(id)
                        this.students[index].isDeactivated = false
                    }
                    this.activatingAccountLoader = false
                    this.snackbar.message = 'Account activated'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                .catch(error => {
                    this.snackbar.message = error
                    this.$EventBus.$emit('snackbar', this.snackbar)
                    this.activatingAccountLoader = false
                })
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>